import { Grid, Typography, Box, useTheme } from '@mui/material';
import { useForm } from 'react-hook-form';

import { updateKPCS, updateKPCSC } from 'apis/survey';
import useSurvey from 'store/survey/useSurvey';
import useNotification from 'hooks/useNotification';
import MuiDialog from 'components/MuiDialog';
import {
  TKPCSCDefaultValues,
  SurveyDialogProps,
} from 'routes/Main/Survey/type';

import CommonPatientInfo from '../../components/CommonPatientInfo';
import KPCSCContents from './KPCSCContents';
import { useState } from 'react';
import KPCSCContents2 from './KPCSCContents2';
import KPCSCContents3 from './KPCSCContents3';
import KPCSCContents401 from './KPCSCContents4_1';
import KPCSCContents402 from './KPCSCContents4_2';
import KPCSCContents5 from './KPCSCContents5';
import KPCSCContents6 from './KPCSCContents6';

const KPCSC = (props: SurveyDialogProps<TKPCSCDefaultValues>) => {
  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    user_id,
    patientInfo,
    nurseName,
    onClose,
  } = props;

  const { onUpdateIsSave } = useSurvey();
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();
  const { palette } = useTheme();

  const { handleSubmit, watch, register, getValues, setValue } = useForm({
    defaultValues,
  });

  // 1-9번
  const [sum1, setSum1] = useState(0);
  // 8번 인풋
  const [pressure, setPressure] = useState(
    getValues('no08_1') ? getValues('no08_1') * 2 : 0
  );

  // 10-18번
  const [sum2, setSum2] = useState(0);
  // 18번 인풋
  const [ekg, setEKG] = useState(
    getValues('no18_1') ? getValues('no18_1') * 2 : 0
  );

  // 19-32번
  const [sum3, setSum3] = useState(0);
  // 29번 인풋
  const [prostate, setProstate] = useState(
    getValues('no29_1') ? getValues('no29_1') * 6 : 0
  );
  // 33-37번
  const [sum4, setSum4] = useState(0);
  // 35번 인풋
  const [exercise1, setExercise1] = useState(
    getValues('no35_1') ? getValues('no35_1') * 3 : 0
  );
  // 36번 인풋
  const [exercise2, setExercise2] = useState(
    getValues('no36_1') ? getValues('no36_1') * 5 : 0
  );

  // 38-44번
  const [sum5, setSum5] = useState(0);
  // 41번 인풋
  const [perineum, setPerineum] = useState(
    getValues('no41_1') ? getValues('no41_1') : 0
  );
  // 42번 인풋
  const [linen, setLinen] = useState(
    getValues('no42_1') ? getValues('no42_1') * 1.5 : 0
  );
  // 45-49번
  const [sum6, setSum6] = useState(0);
  const [lactation, setLactation] = useState(
    getValues('no49_1') ? getValues('no49_1') * 4 : 0
  );

  // 50-53번 인풋값들
  const [num50, setNum50] = useState(
    getValues('no50_1') ? getValues('no50_1') : 0
  );
  const [num51, setNum51] = useState(
    getValues('no51_1') ? getValues('no51_1') : 0
  );
  const [num52, setNum52] = useState(
    getValues('no52_1') ? getValues('no52_1') * 2 : 0
  );
  const [num53, setNum53] = useState(
    getValues('no53_1') ? getValues('no53_1') * 2 : 0
  );

  // 54-59번 인풋값들
  const [num54, setNum54] = useState(
    getValues('no54_1') ? getValues('no54_1') * 2 : 0
  );
  const [num55, setNum55] = useState(
    getValues('no55_1') ? getValues('no55_1') * 0.5 : 0
  );
  const [num56, setNum56] = useState(
    getValues('no56_1') ? getValues('no56_1') : 0
  );
  const [num57, setNum57] = useState(
    getValues('no57_1') ? getValues('no57_1') * 0.3 : 0
  );
  const [num58, setNum58] = useState(
    getValues('no58_1') ? getValues('no58_1') * 3 : 0
  );
  const [num59, setNum59] = useState(
    getValues('no59_1') ? getValues('no59_1') : 0
  );
  const [num60, setNum60] = useState(
    getValues('no60_1') ? getValues('no60_1') * 0.5 : 0
  );

  // 61-74번
  const [sum7, setSum7] = useState(0);

  const [num62, setNum62] = useState(
    getValues('no62_1') ? getValues('no62_1') : 0
  );
  const [num63, setNum63] = useState(
    getValues('no63_1') ? getValues('no63_1') : 0
  );

  const [num65, setNum65] = useState(
    getValues('no65_1') ? getValues('no65_1') : 0
  );
  const [num70, setNum70] = useState(
    getValues('no70_1') ? getValues('no70_1') * 1.5 : 0
  );
  const [num73, setNum73] = useState(
    getValues('no73_1') ? getValues('no73_1') * 6 : 0
  );

  // 75-83번
  const [sum8, setSum8] = useState(0);
  const [sum9, setSum9] = useState(0);
  const [num82, setNum82] = useState(
    getValues('no82_1') ? getValues('no82_1') * 6 : 0
  );

  const onSubmit = (data: TKPCSCDefaultValues) => {
    const { patient_id } = patientInfo;
    const {} = data;

    const request = {
      user_id,
      patient_id: patientInfo.patient_id,
      kpcsc_survey: { ...data },
    };

    updateKPCSC(request)
      .then(({ data: { rc } }) => {
        if (rc !== 1) return onResultCode(rc);
        onUpdateIsSave(true);
        onSuccess('저장되었습니다');
      })
      .catch(e => onFail('저장에 실패하였습니다', e));
  };

  const formProps = {
    disabled,
    watch,
    register,
    getValues,
    setValue,
    onRequired,
  };

  const 합계 =
    sum1 +
    pressure +
    sum2 +
    ekg +
    sum3 +
    prostate +
    sum4 +
    exercise1 +
    exercise2 +
    sum5 +
    perineum +
    linen +
    sum6 +
    lactation +
    num50 +
    num51 +
    num52 +
    num53 +
    num54 +
    num55 +
    num56 +
    num57 +
    num58 +
    num59 +
    num60 +
    sum7 +
    num62 +
    num63 +
    num65 +
    num70 +
    num73 +
    sum8 +
    sum9 +
    num82;

  return (
    <MuiDialog.SurveyForm
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Grid
        container
        wrap="wrap"
        rowSpacing={5}
        columnSpacing={3}
        sx={{ py: 5, px: 1 }}
      >
        <Typography
          sx={{
            margin: '40px auto 0px auto',
            fontWeight: '700',
            fontSize: '16px',
            textAlign: 'center',
          }}
        >
          한국형 중환자간호 분류도구(KPCSC)
        </Typography>
        <CommonPatientInfo patientInfo={patientInfo} nurseName={nurseName} />
        {/* 1-18번 */}
        <KPCSCContents
          {...formProps}
          sum1={sum1}
          setSum1={setSum1}
          pressure={pressure}
          setPressure={setPressure}
          sum2={sum2}
          setSum2={setSum2}
          ekg={ekg}
          setEKG={setEKG}
        />
        {/* 19-37번 */}
        <KPCSCContents2
          {...formProps}
          sum3={sum3}
          setSum3={setSum3}
          prostate={prostate}
          setProstate={setProstate}
          sum4={sum4}
          setSum4={setSum4}
          exercise1={exercise1}
          setExercise1={setExercise1}
          exercise2={exercise2}
          setExercise2={setExercise2}
        />
        {/* 38-49번 */}
        <KPCSCContents3
          {...formProps}
          sum5={sum5}
          setSum5={setSum5}
          perineum={perineum}
          setPerineum={setPerineum}
          linen={linen}
          setLinen={setLinen}
          sum6={sum6}
          setSum6={setSum6}
          lactation={lactation}
          setLactation={setLactation}
        />
        {/* 50-53 번*/}
        <KPCSCContents401
          {...formProps}
          num50={num50}
          setNum50={setNum50}
          num51={num51}
          setNum51={setNum51}
          num52={num52}
          setNum52={setNum52}
          num53={num53}
          setNum53={setNum53}
        />
        {/* 54-60 번*/}
        <KPCSCContents402
          {...formProps}
          num54={num54}
          setNum54={setNum54}
          num55={num55}
          setNum55={setNum55}
          num56={num56}
          setNum56={setNum56}
          num57={num57}
          setNum57={setNum57}
          num58={num58}
          setNum58={setNum58}
          num59={num59}
          setNum59={setNum59}
          num60={num60}
          setNum60={setNum60}
        />
        {/* 61-74번 */}
        <KPCSCContents5
          {...formProps}
          sum7={sum7}
          setSum7={setSum7}
          num62={num62}
          setNum62={setNum62}
          num63={num63}
          setNum63={setNum63}
          num65={num65}
          setNum65={setNum65}
          num70={num70}
          setNum70={setNum70}
          num73={num73}
          setNum73={setNum73}
        />
        {/* 75-83번 */}
        <KPCSCContents6
          {...formProps}
          sum8={sum8}
          setSum8={setSum8}
          sum9={sum9}
          setSum9={setSum9}
          num82={num82}
          setNum82={setNum82}
        />

        <Box
          display={'flex'}
          flexDirection={'column'}
          alignItems={'flex-end'}
          sx={{ marginTop: '20px', width: '98%' }}
        >
          <Typography
            gutterBottom
            minWidth={115}
            fontWeight={700}
            fontSize={20}
            variant="subtitle1"
          >
            합계 : {합계.toFixed(1)} 점
          </Typography>
          <Typography
            minWidth={80}
            variant="caption"
            sx={{ color: `${palette.primary.main}` }}
          >
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                I군 :
              </Box>
              1~62점
            </Typography>
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                II군:
              </Box>
              63~99점
            </Typography>
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                III군:
              </Box>
              100~139점
            </Typography>
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                IV군:
              </Box>
              140점 이상
            </Typography>
          </Typography>
        </Box>
      </Grid>
    </MuiDialog.SurveyForm>
  );
};

export default KPCSC;
